import { render, staticRenderFns } from "./LayoutNoheaderandsidebar.vue?vue&type=template&id=83514c82&"
import script from "./LayoutNoheaderandsidebar.vue?vue&type=script&lang=js&"
export * from "./LayoutNoheaderandsidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports